"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.insertOverLayoutWidget = exports.insertLeadingWidget = exports.insertLeadingVoid = exports.insertAndReplaceWithSelection = exports.insertAndOverride = exports.splitAndInsert = exports.insertIntoH2Placeholder = exports.maybeInsertLink = exports.maybeInsertLinkOverText = exports.insertAndAssume = void 0;
var Models_1 = require("ContentTokens/Models");
var slate_1 = require("slate");
var Utils_1 = require("../Utils");
var WidgetActions_1 = require("./WidgetActions");
var TokenModels_1 = __importDefault(require("ContentTokens/TokenModels"));
var QwilrEditorTelemetry_1 = require("../QwilrEditorTelemetry");
var lodash_1 = __importDefault(require("lodash"));
var Image_1 = require("../Widgets/ImageWidget/Image");
var Variable_1 = require("../WidgetRegistry/Widgets/Variable");
var EditorWidgetRegistry_1 = require("../WidgetRegistry/EditorWidgetRegistry");
var Paragraph_1 = require("../WidgetRegistry/Widgets/Paragraph");
var insertAndAssume = function (editor, fragment) {
    if (!editor.selection) {
        return;
    }
    var existingEntry = (0, Utils_1.getClosestBlock)(editor, slate_1.Range.start(editor.selection).path);
    if (!existingEntry) {
        return;
    }
    slate_1.Editor.withoutNormalizing(editor, function () {
        if (!canMergeLastNodeInline(fragment) && !atEnd(editor)) {
            slate_1.Transforms.splitNodes(editor, { always: true });
            (0, Utils_1.moveToEndOfPreviousBlock)(editor);
        }
        slate_1.Transforms.splitNodes(editor, { always: true });
        var fragmentLeadingNode = fragment[0];
        if (!slate_1.Editor.isVoid(editor, fragmentLeadingNode)) {
            fragment[0] = __assign(__assign({}, fragmentLeadingNode), slate_1.Node.extractProps(existingEntry[0]));
        }
        slate_1.Transforms.insertFragment(editor, fragment, { voids: true });
        var pasted = (0, Utils_1.getNext)(editor, existingEntry[1], Utils_1.isBlockElement);
        if (!pasted) {
            return;
        }
        var isBlockVoid = slate_1.Editor.isVoid(editor, fragmentLeadingNode) && slate_1.Editor.isBlock(editor, fragmentLeadingNode);
        if (!isBlockVoid) {
            slate_1.Transforms.mergeNodes(editor, { at: pasted[1] });
        }
    });
};
exports.insertAndAssume = insertAndAssume;
var extractLinkFromFragment = function (fragment) {
    if (fragment.length !== 1) {
        return;
    }
    if (!slate_1.Element.isElement(fragment[0])) {
        return;
    }
    var _a = __read(fragment[0].children, 1), maybeLinkText = _a[0];
    if (!slate_1.Text.isText(maybeLinkText)) {
        return;
    }
    var text = maybeLinkText.text;
    try {
        new URL(text);
        return text;
    }
    catch (err) {
        return;
    }
};
var maybeInsertLinkOverText = function (editor, fragment, editorTelemetry) {
    var link = extractLinkFromFragment(fragment);
    if (!link) {
        return;
    }
    var _a = __read(slate_1.Editor.nodes(editor, {
        match: function (curr) {
            return slate_1.Element.isElement(curr) && curr.type === Models_1.InlineType.Link;
        },
    }), 1), existingLinkNodesInSelection = _a[0];
    if (!!existingLinkNodesInSelection) {
        slate_1.Transforms.unwrapNodes(editor, {
            match: function (curr) {
                return slate_1.Element.isElement(curr) && curr.type === Models_1.InlineType.Link;
            },
        });
    }
    var newLink = TokenModels_1.default.link.createSlateJson([], link);
    slate_1.Transforms.wrapNodes(editor, newLink, { split: true });
    lodash_1.default.defer(function () {
        slate_1.Transforms.setSelection(editor, { focus: editor.selection.anchor, anchor: editor.selection.focus });
    });
    editorTelemetry.hyperlinkURLAdded(link, QwilrEditorTelemetry_1.HyperlinkAddedSource.ExpandedSelectionPaste);
    return true;
};
exports.maybeInsertLinkOverText = maybeInsertLinkOverText;
var maybeInsertLink = function (editor, fragment, editorTelemetry) {
    var link = extractLinkFromFragment(fragment);
    if (!link) {
        return;
    }
    var linkFragment = [
        (0, Paragraph_1.createParagraphNode)([TokenModels_1.default.link.createSlateJson([TokenModels_1.default.text.createSlateJson(link, {})], link)]),
    ];
    (0, exports.insertAndAssume)(editor, linkFragment);
    editorTelemetry.hyperlinkURLAdded(link, QwilrEditorTelemetry_1.HyperlinkAddedSource.CollapsedSelectionPaste);
    return true;
};
exports.maybeInsertLink = maybeInsertLink;
var insertIntoH2Placeholder = function (editor, fragment) {
    if (getFirstBlockType(fragment) === "heading1") {
        (0, exports.insertAndOverride)(editor, fragment);
    }
    else {
        (0, exports.insertAndAssume)(editor, fragment);
    }
};
exports.insertIntoH2Placeholder = insertIntoH2Placeholder;
var splitAndInsert = function (editor, fragment) {
    if (!editor.selection) {
        return;
    }
    slate_1.Transforms.splitNodes(editor, { always: true });
    var splitPointRef = slate_1.Editor.pathRef(editor, editor.selection.anchor.path);
    (0, exports.insertAndOverride)(editor, fragment);
    if (!lastBlockNotText(fragment) && !!splitPointRef.current) {
        var blockEntry = (0, Utils_1.getClosestBlock)(editor, splitPointRef.current);
        if (!blockEntry) {
            return;
        }
        slate_1.Transforms.setNodes(editor, getLastBlockProps(fragment), { at: blockEntry[1] });
    }
    splitPointRef.unref();
};
exports.splitAndInsert = splitAndInsert;
var insertAndOverride = function (editor, fragment, usingAdvancedTokens) {
    if (!editor.selection) {
        return;
    }
    var startPoint = slate_1.Range.start(editor.selection);
    var existingEntry = (0, Utils_1.getClosestBlock)(editor, startPoint.path);
    if (!existingEntry) {
        return;
    }
    if (!!usingAdvancedTokens && isVariableFragment(fragment) && (0, Image_1.isImageNode)(existingEntry[0])) {
        pasteVariableIntoImage(editor, existingEntry[1], fragment);
        return;
    }
    if (!canMergeLastNodeInline(fragment) && !atEnd(editor)) {
        slate_1.Transforms.splitNodes(editor, { always: true });
        (0, Utils_1.moveToEndOfPreviousBlock)(editor);
    }
    slate_1.Editor.withoutNormalizing(editor, function () {
        if (!canMergeLastNodeInline(fragment) && !atEnd(editor)) {
            slate_1.Transforms.splitNodes(editor, { always: true });
            (0, Utils_1.moveToEndOfPreviousBlock)(editor);
        }
        slate_1.Transforms.splitNodes(editor, { always: true });
        slate_1.Transforms.insertFragment(editor, fragment, { voids: true });
        var pasted = (0, Utils_1.getNext)(editor, existingEntry[1], Utils_1.isBlockElement);
        if (!pasted) {
            return;
        }
        if (!slate_1.Editor.isVoid(editor, existingEntry[0])) {
            slate_1.Transforms.mergeNodes(editor, { at: pasted[1] });
        }
    });
};
exports.insertAndOverride = insertAndOverride;
var insertAndReplaceWithSelection = function (editor, fragment, selections) {
    var _a, _b;
    var widgetEntries = selections
        .sort(function (a, b) { return slate_1.Path.compare(a.path, b.path); })
        .map(function (selection) { return slate_1.Editor.node(editor, selection.path); });
    if (!widgetEntries.every(function (widget) { return slate_1.Element.isElement(widget[0]); })) {
        return;
    }
    var lastWidgetPath = (_a = widgetEntries[widgetEntries.length - 1]) === null || _a === void 0 ? void 0 : _a[1];
    if (!(lastWidgetPath === null || lastWidgetPath === void 0 ? void 0 : lastWidgetPath.length))
        return;
    var firstWidgetPath = (_b = widgetEntries[0]) === null || _b === void 0 ? void 0 : _b[1];
    if (!(firstWidgetPath === null || firstWidgetPath === void 0 ? void 0 : firstWidgetPath.length))
        return;
    var targetPastePath = selections.length === 1 ? firstWidgetPath : slate_1.Path.next(lastWidgetPath);
    slate_1.Editor.withoutNormalizing(editor, function () {
        if (selections.length === 1) {
            slate_1.Transforms.removeNodes(editor, { at: firstWidgetPath });
        }
        slate_1.Transforms.insertNodes(editor, fragment, { at: targetPastePath });
    });
    var insertPaths = fragment.reduce(function (acc, _, index) {
        if (index === 0)
            return [targetPastePath];
        var prevInsertPath = acc[index - 1];
        if (!prevInsertPath)
            return acc;
        return __spreadArray(__spreadArray([], __read(acc), false), [slate_1.Path.next(prevInsertPath)], false);
    }, []);
    return insertPaths;
};
exports.insertAndReplaceWithSelection = insertAndReplaceWithSelection;
var insertLeadingVoid = function (editor, fragment) {
    if (!atStart(editor)) {
        (0, exports.splitAndInsert)(editor, fragment);
    }
    else {
        (0, exports.insertAndOverride)(editor, fragment);
    }
};
exports.insertLeadingVoid = insertLeadingVoid;
var insertLeadingWidget = function (editor, fragment) {
    if (!editor.selection) {
        return;
    }
    var shouldMergeEnd = !atEnd(editor) && canMergeLastNodeInline(fragment);
    slate_1.Transforms.splitNodes(editor);
    var startPoint = slate_1.Range.start(editor.selection);
    var blockEntry = (0, Utils_1.getClosestBlock)(editor, startPoint.path);
    if (!blockEntry) {
        return;
    }
    var shouldReplaceBlock = slate_1.Node.string(blockEntry[0]) === "";
    var replaceBlockPath = slate_1.Editor.pathRef(editor, blockEntry[1]);
    var insertPointRef;
    var wasAtEndOfContent = false;
    if (atStart(editor) && !shouldReplaceBlock) {
        insertPointRef = slate_1.Editor.pointRef(editor, startPoint);
    }
    else {
        var nextText = (0, Utils_1.getNext)(editor, startPoint.path, slate_1.Text.isText);
        if (nextText) {
            insertPointRef = slate_1.Editor.pointRef(editor, { path: nextText[1], offset: 0 });
        }
        else {
            wasAtEndOfContent = true;
        }
    }
    slate_1.Transforms.insertNodes(editor, fragment);
    var lastInsertedBlock = insertPointRef && insertPointRef.current && (0, Utils_1.getPrevious)(editor, insertPointRef.current.path, Utils_1.isBlockElement);
    if (lastInsertedBlock) {
        slate_1.Transforms.select(editor, slate_1.Editor.end(editor, lastInsertedBlock[1]));
    }
    else if (wasAtEndOfContent) {
        slate_1.Transforms.select(editor, slate_1.Editor.end(editor, []));
    }
    if (shouldReplaceBlock && replaceBlockPath.current) {
        slate_1.Transforms.removeNodes(editor, { at: replaceBlockPath.current });
    }
    if (shouldMergeEnd) {
        var newStartPoint = slate_1.Range.start(editor.selection);
        var currBlock = (0, Utils_1.getClosestBlock)(editor, newStartPoint.path);
        if (currBlock && slate_1.Node.string(currBlock[0]) !== "") {
            var nextBlockEntry = (0, Utils_1.getNext)(editor, newStartPoint.path, Utils_1.isBlockElement);
            if (nextBlockEntry) {
                slate_1.Transforms.mergeNodes(editor, { at: nextBlockEntry[1] });
            }
        }
    }
    replaceBlockPath.unref();
    if (insertPointRef) {
        insertPointRef.unref();
    }
};
exports.insertLeadingWidget = insertLeadingWidget;
var insertOverLayoutWidget = function (editor, fragment) {
    if (!editor.selection) {
        return;
    }
    var startPoint = slate_1.Range.start(editor.selection);
    var pathToLayoutWidget = [startPoint.path[0]];
    var nextTextAfterLayoutWidget = (0, Utils_1.getNext)(editor, pathToLayoutWidget, slate_1.Text.isText);
    var nextPointAfterLayoutWidget = slate_1.Editor.pointRef(editor, slate_1.Editor.start(editor, nextTextAfterLayoutWidget[1]));
    slate_1.Transforms.removeNodes(editor, { at: pathToLayoutWidget });
    slate_1.Transforms.insertNodes(editor, fragment, {
        at: pathToLayoutWidget,
    });
    var lastTextInPastedFragment = (0, Utils_1.getPrevious)(editor, nextPointAfterLayoutWidget.unref().path, slate_1.Text.isText);
    slate_1.Transforms.select(editor, slate_1.Editor.end(editor, lastTextInPastedFragment[1]));
    return;
};
exports.insertOverLayoutWidget = insertOverLayoutWidget;
var getLastBlockProps = function (fragment) {
    var lastBlock = fragment[fragment.length - 1];
    if (!slate_1.Element.isElement(lastBlock)) {
        throw new Error("Can't get last block props for a text node");
    }
    return {
        type: lastBlock.type,
        data: lastBlock.data,
        isVoid: lastBlock.isVoid,
    };
};
var getFirstBlockType = function (fragment) {
    if (slate_1.Text.isText(fragment[0])) {
        return;
    }
    return fragment[0].type;
};
var canMergeLastNodeInline = function (fragment) {
    var node = fragment[fragment.length - 1];
    return node ? canMergeInline(node) : false;
};
var canMergeInline = function (node) {
    if (slate_1.Text.isText(node)) {
        return true;
    }
    var config = (0, EditorWidgetRegistry_1.getGenericConfigByType)(node.type);
    if (config && config.nodeType === "textElement") {
        return true;
    }
    return !!node.isVoid && (0, Utils_1.isInline)(node);
};
var lastBlockNotText = function (fragment) {
    var lastBlock = fragment[fragment.length - 1];
    if (slate_1.Text.isText(lastBlock)) {
        return false;
    }
    if (lastBlock.isVoid) {
        return true;
    }
    return lastBlock.type === "table";
};
var atEnd = function (editor) {
    if (!editor.selection) {
        return false;
    }
    var startPoint = slate_1.Range.start(editor.selection);
    var startBlockEntry = (0, Utils_1.getClosestBlock)(editor, startPoint.path);
    var endBlockEntry = (0, Utils_1.getClosestBlock)(editor, slate_1.Range.end(editor.selection).path);
    if (!startBlockEntry || !endBlockEntry) {
        return false;
    }
    if (startBlockEntry[0] !== endBlockEntry[0]) {
        return true;
    }
    var blockTextLength = slate_1.Node.string(startBlockEntry[0]).length;
    var adjustedOffset = (0, Utils_1.getOffsetFrom)(editor, startBlockEntry[1], startPoint.path) + startPoint.offset;
    return adjustedOffset === blockTextLength;
};
var atStart = function (editor) {
    if (!editor.selection) {
        return false;
    }
    var startPoint = slate_1.Range.start(editor.selection);
    var parentBlockEntry = (0, Utils_1.getClosestBlock)(editor, startPoint.path);
    if (!parentBlockEntry) {
        return false;
    }
    var offsetFromStart = (0, Utils_1.getOffsetFrom)(editor, parentBlockEntry[1], startPoint.path);
    return offsetFromStart == 0 && startPoint.offset == 0;
};
var isVariableFragment = function (fragment) {
    var firstElement = fragment[0];
    var singleParagraph = fragment.length === 1 && slate_1.Element.isElement(firstElement) && firstElement.type === "paragraph";
    if (!singleParagraph) {
        return false;
    }
    var singleVariableChild = firstElement.children.length === 1 && (0, Variable_1.isVariableNode)(firstElement.children[0]);
    if (!singleVariableChild) {
        return false;
    }
    return true;
};
var pasteVariableIntoImage = function (editor, path, fragment) {
    if (!slate_1.Element.isElement(fragment[0])) {
        return;
    }
    var variable = fragment[0].children[0];
    (0, WidgetActions_1.updateImageWidget)(editor, path, {
        src: "",
        variable: { name: variable.data.variableName, label: variable.data.variableLabel },
    });
};
